export interface GuideDefinition {
  key: "buyers" | "sellers";
  title: string;
  href: string;
  cta: string;
  ariaLabel: string;
  description: string;
  analyticsEvent: "download_buyers_guide" | "download_sellers_guide";
}

export const BUYERS_GUIDE: GuideDefinition = {
  key: "buyers",
  title: "Buyer’s Guide",
  href: "/guides/Hadassah-Homes-Buyers-Guide-Website.pdf",
  cta: "Download Buyer’s Guide",
  ariaLabel: "Download the Hadassah Homes Buyer’s Guide PDF (opens in a new tab)",
  description:
    "Learn what to expect throughout the home-buying process, from preparing financially and beginning your search to making an offer and closing on your home.",
  analyticsEvent: "download_buyers_guide",
};

export const SELLERS_GUIDE: GuideDefinition = {
  key: "sellers",
  title: "Seller’s Guide",
  href: "/guides/Hadassah-Homes-Sellers-Guide-Website.pdf",
  cta: "Download Seller’s Guide",
  ariaLabel: "Download the Hadassah Homes Seller’s Guide PDF (opens in a new tab)",
  description:
    "Get a clear overview of what to expect when selling your home, from preparing your property and understanding the market to offers, negotiations, and closing.",
  analyticsEvent: "download_sellers_guide",
};

/** Pushes a guide download event into the existing GTM dataLayer. */
export const trackGuideDownload = (guide: GuideDefinition, location: string) => {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: guide.analyticsEvent,
    guide_name: guide.title,
    guide_url: guide.href,
    location,
  });
};
